import React, { useState } from 'react';
import WarningIcon from '../../../assets/WarningIcon';
import UnallocatedCard from '../UnallocatedCard';
import { IPaxDriverAllocation } from '../../../interfaces/driverPaxAllocation';
import WarningIconDark from '../../../assets/WarningIconDark';
import { calculatePaxPercentage } from '../../../utils/utility';

interface AllocationsPaxProps<T> {
  bgColor?: string;
  textColor?: string;
  borderColor?: string;
  buttonText?: string;
  message: string;
  heading: string;
  totalPax?: number;
  totalAllocatedPax?: number;
  data: T[];
}
const AllocationsPax = <T extends IPaxDriverAllocation>({
  bgColor = '#FDE5D8',
  textColor = 'text-orange-600',
  borderColor = '#004E9B',
  buttonText = 'View',
  message,
  heading,
  data,
  totalPax,
  totalAllocatedPax,
}: AllocationsPaxProps<T>) => {
  const [isVisible, setIsVisible] = useState(false);

  const percentageNeeded = calculatePaxPercentage(
    totalPax || 0,
    totalAllocatedPax || 0,
  )?.toFixed(0);

  return (
    <div
      className={`flex justify-between items-center bg-backgroundColor-tableBgColor ${textColor} rounded p-3 mb-1`}
    >
      <span>
        <div>
          <div className="block dark:hidden">
            <WarningIcon />
          </div>
          <div className="hidden dark:block">
            <WarningIconDark />
          </div>
        </div>
      </span>
      <span className="flex ml-4">
        <span>{percentageNeeded}%</span>
        <span className="text-[#1E1E1E] ml-1 mr-10">{message}</span>
      </span>

      <button
        disabled={Number(percentageNeeded) <= 0}
        onClick={() => setIsVisible(true)}
        className={`text-[${borderColor}] border pl-4 pr-4 pt-1 pb-1 rounded ${
          Number(percentageNeeded) <= 0
            ? 'cursor-not-allowed bg-[var(--disableBtnBg)] text-[var(--disableBtnColor)] border--[var(--disableBtnBorder)]'
            : 'bg-white border-[${borderColor}]'
        }`}
      >
        {buttonText}
      </button>

      <UnallocatedCard
        isVisible={isVisible}
        setIsVisible={setIsVisible}
        heading={heading}
        data={data}
      />
    </div>
  );
};

export default AllocationsPax;
